import React from "react";

const ImagenContainer = () => {
  return (
    <div className="py-2 my-4">
      <img
        src="assets/imagenes/web_mc_infografia_proceso obtencion licencia_corregida.jpg"
        class="img1 img-fluid"
      ></img>
      <img
        src="assets/imagenes/web_mc_celular_infografia_proceso_obtencion_licencia-02.png"
        class="img2 img-fluid"
      ></img>
    </div>
  );
};

export default ImagenContainer;
